import { useState } from "react";
import { topicTags, hotTopics } from "@/mocks/expose";

const heatText = ["酝酿中", "升温", "发酵", "高热"];

export default function TopicWall() {
  const [active, setActive] = useState(0);
  const [round, setRound] = useState(0);

  const rotate = () => {
    setRound((r) => r + 1);
    setActive(0);
  };

  // 轮换展示一批话题（模拟"换一批"）
  const shown = topicTags.slice(round % 2, (round % 2) + 8);

  const current = shown[active];

  return (
    <section id="topics" className="border-y border-background-200/70 bg-background-100/70">
      <div className="mx-auto max-w-page px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
              <i className="ri-price-tag-3-line text-base"></i>
              话题墙 · Topic Wall
            </p>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今天全网都在深挖什么
            </h2>
          </div>
          <button
            type="button"
            onClick={rotate}
            className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-foreground-400"
          >
            <i className="ri-refresh-line"></i> 换一批
          </button>
        </div>

        <p className="mt-2 max-w-2xl text-sm text-foreground-600">
          标签即入口。点进任意话题，就能看到围绕它的线索、证据与读者补刀——所有讨论都按话题归类、按热度排序。
        </p>

        <div className="mt-6 flex flex-wrap gap-2 md:gap-2.5">
          {shown.map((t, i) => {
            const isActive = i === active;
            return (
              <button
                key={`${round}-${t.name}`}
                type="button"
                onClick={() => setActive(i)}
                className={`inline-flex items-center gap-2 whitespace-nowrap rounded-full border px-3.5 py-2 text-sm transition-colors ${
                  isActive
                    ? "border-primary-500 bg-primary-500 font-medium text-background-50"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-foreground-400"
                }`}
              >
                {t.live && !isActive && (
                  <span className="h-1.5 w-1.5 rounded-full bg-accent-500"></span>
                )}
                {t.name}
                <span className={`text-[10px] ${isActive ? "text-background-50/80" : "text-foreground-400"}`}>
                  {heatText[Math.min(3, Math.floor(t.heat / 25))]}
                </span>
              </button>
            );
          })}
        </div>

        <div className="mt-6 grid gap-6 lg:grid-cols-5">
          {/* 当前选中话题说明 */}
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 lg:col-span-2">
            <div className="flex items-center justify-between">
              <span className="font-heading text-xl font-bold text-foreground-950">
                #{current.name}
              </span>
              <span className="text-xs text-foreground-500">热度 {current.heat}%</span>
            </div>
            <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-100">
              <div
                className="h-full rounded-full bg-accent-500"
                style={{ width: `${current.heat}%` }}
              ></div>
            </div>
            <p className="mt-4 text-sm leading-6 text-foreground-700">
              围绕「{current.name}」方向，编辑部已归集线索
              {Math.round(current.heat * 1.3)} 条，其中经交叉验证的实锤
              {Math.round(current.heat / 3)} 条。读者补刀仍在更新，尚未完全收口。
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                线索可跟
              </span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
                证据待补
              </span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
                讨论进行中
              </span>
            </div>
          </div>

          {/* 热点发酵榜 */}
          <div className="rounded-lg border border-background-200/80 bg-background-50 p-5 lg:col-span-3">
            <div className="flex items-center justify-between">
              <h3 className="text-sm font-semibold text-foreground-900">
                <i className="ri-fire-line mr-1 text-accent-600"></i>
                正在发酵 · 实时
              </h3>
              <span className="text-xs text-foreground-400">热度每 5 分钟更新</span>
            </div>
            <ul className="mt-4 divide-y divide-background-100">
              {hotTopics.map((h) => (
                <li key={h.rank} className="flex items-center gap-3 py-3">
                  <span
                    className={`w-5 text-center font-heading text-base font-black ${
                      h.rank <= 2 ? "text-primary-600" : "text-secondary-300"
                    }`}
                  >
                    {h.rank}
                  </span>
                  <span className="min-w-0 flex-1 truncate text-sm text-foreground-800">
                    {h.title}
                  </span>
                  <span className="hidden items-center gap-1 text-xs text-foreground-400 sm:flex">
                    <i
                      className={
                        h.trend === "up"
                          ? "ri-arrow-up-line text-primary-600"
                          : h.trend === "down"
                          ? "ri-arrow-down-line text-secondary-400"
                          : "ri-drag-move-2-line text-foreground-300"
                      }
                    ></i>
                    {h.views}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}